import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject, OnChanges, SimpleChanges, AfterViewInit, ChangeDetectorRef, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { RepresentadosListPreStageComponent } from './representados-list-pre-stage.component';

import { Subscription } from 'rxjs';
import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { NifValidationService } from '@infrastructure/NifValidation/nif-validation.service';
import { BeneficiaryIdsService } from '@infrastructure/Beneficiaries/beneficiary-ids.service';
import { LegalRepresentationState, LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { StateCode, StatePhase } from '@infrastructure/Models/const.stateCodePhase';

@Component({
  selector: 'representados-list-table-edit-pre-stage',
  templateUrl: './representados-list-table-edit-pre-stage.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class RepresentadosListTableEditPreStageComponent extends TableEditBase<models.BeneficiaryListVM> implements OnInit, OnDestroy, OnChanges{
  

  @Input() dropdowns: models.WorkflowDropdownsVM;
  @Input() nifDeceased: number;

  @Input() nifRepresentanteLegal: number;
  @Input() estadoPendente: boolean;

  @Input() stateCode: string;
  @Input() statePhase: string;

  @Input() isBeneficiary: boolean;

  @Output() isClosing = new EventEmitter<boolean>();

  //@ViewChild('tableItemEditForm') tableItemEditForm;

  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  public isVisibleSurvivalPensionBenefit = false
  public isVisibleReimbursementFuneralBenefit = false
  public isVisibleFuneralAllowanceBenefit = false

  
  public dataFalecimento: Date;

  public typesRepresentation: models.DimensionVM[];

  
  public dropListRepresentationType: models.Options[] = [];
  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;

  public preFilledProperties: PreFilledProperty[] = [];

  public rlRlStateAguardaDocumentos = false;

  public isRLIndeferida: boolean = false;
  public isAIndeferir: boolean = false;

  constructor(@Inject(RepresentadosListPreStageComponent) private parent: Component,
    private modalService: ModalService,
    private beneficiaryIDsService: BeneficiaryIdsService,
    private beneficiaryValuesService: BeneficiaryValuesService,
    private legalRepresentationState: LegalRepresentationStateService,
    private commonDataService: CommonDataService, private nifValidationService: NifValidationService) {
    super(parent, modalService);
   

    const domains = [
      DomainCodes.yesNo,
      //DomainCodes.genders,
      //DomainCodes.martialStatus,
      //DomainCodes.identificationType
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          //this.genders = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.genders).dimensions;
          //this.maritalStatus = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.martialStatus).dimensions;
          //this.documentTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.identificationType).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dropdowns) {
      this.dropListRepresentationType = this.dropdowns.options
        .filter(el => el.dropdown === "DropdownRepresentationType");
    }
  }


  ngOnInit(): void {
    super.ngOnInit();
    const fieldArray = [
      "hasNacPT",
      "NIF"
    ];
    this.preFilledProperties =
      this.beneficiaryValuesService
        .getPreFilledProperties(this.item.beneficiaryID, this.item, fieldArray);
    this.rlRlStateAguardaDocumentos = this.item.stateRL === 3;

    if (this.stateCode == StateCode.Invalidado && this.statePhase == StatePhase.RLIndeferida) {
      this.isRLIndeferida = true;
    }

    if (this.item.stateRL == LegalRepresentationState.AIndeferir) {
      this.isAIndeferir = true;
    }
  }

  public toggleVisibilitySurvivalPensionBenefit() {
    this.isVisibleSurvivalPensionBenefit = !this.isVisibleSurvivalPensionBenefit
  }

  public toggleVisibilityReimbursementFuneralBenefit() {
    this.isVisibleReimbursementFuneralBenefit = !this.isVisibleReimbursementFuneralBenefit
  }

  public toggleVisibilityFuneralAllowanceBenefit() {
    this.isVisibleFuneralAllowanceBenefit = !this.isVisibleFuneralAllowanceBenefit
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
    this.isClosing.emit(true);
  }


  onEdit(isEdit: boolean) {

    this.item.hasNIFPT = true;
    //if (this.item.hasNIFPT?.toString() == 'false') {
    //  let modal = <models.BaseModalVM>{
    //    isError: false,
    //    message: "WorkflowCreatePM.PreStage.CardRepresentados.NifEstrangeiro",
    //    param: {},
    //    cancelButton: {
    //      hideButton: true,
    //      buttonText: "Ok",
    //      buttonClass: 'btn-primary',
    //      iconClass: "icon-check"
    //    }
    //  };

    //  this.modalService.showModals([modal]);
    //  return;
    //}

    if (!this.nifValidationService.isPessoaSingularNif(this.item.NIF)) {
      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.NifPessoaColectivaWarning",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]);
      return;
    }
    if (this.item.NIF !== null && this.item.NIF !== undefined) {
      if (this.item.NIF.toString().length !== 9) {
        let modal = <models.BaseModalVM>{
          isError: false,
          message: "WorkflowCreatePM.PreStage.CardRepresentados.InvalidNif",
          param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check"
          }
        };

        this.modalService.showModals([modal]);
        return;
      }




    }

    // Verifica se o NIF é igual ao remetente
    if (this.item.NIF?.toString() == this.nifRepresentanteLegal?.toString()) {
      if (this.item.beneficiaryID?.toString() != '1') {
        let modal = <models.BaseModalVM>{
          isError: false,
          message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFSenderLocal",
          param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check"
          }
        };

        this.modalService.showModals([modal]);
        return;

      }
    }

    // Verifica o NIF é igual ao do falecido 
    const duplicateDeceasedNif = this.item.NIF?.toString() == this.nifDeceased?.toString();
    if (duplicateDeceasedNif ) {
      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFDeceased",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]);
      return;
    }   

    //// Verifica se o NIF é igual ao do representante legal 
    //const duplicateRepLegalNif = this.item.NIF?.toString() == this.nifRepresentanteLegal?.toString();

    //if (duplicateRepLegalNif) {

    //  let modal = <models.BaseModalVM>{
    //    isError: false,
    //    message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFRepresentanteLegal",
    //    param: {},
    //    cancelButton: {
    //      hideButton: true,
    //      buttonText: "Ok",
    //      buttonClass: 'btn-primary',
    //      iconClass: "icon-check"
    //    }
    //  };

    //  this.modalService.showModals([modal]);
    //  return;
    //}   


    let listToCompare = [...this.itemList];
    if (isEdit) {
      listToCompare.splice(this.editIndex,1);
    }
    const duplicateNif = listToCompare.filter(el => el.NIF === this.item.NIF).length > 0;
    if (duplicateNif) {

      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNif",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]);
      return;
    }
    //Validar se há apenas um item com Reembolso por despesas de funeral
 
    if (isEdit) {
      const beneficiaryId = this.item.beneficiaryID;
      const itemInList = this.itemList.find(el => el.beneficiaryID === beneficiaryId);
      const indexOfItem = this.itemList.indexOf(itemInList);
      this.itemList[indexOfItem] = this.item;
    }
    listToCompare = [...this.itemList];
    if (!isEdit) {
      listToCompare.push(this.item)
    }
    const moreThanOneRDF = listToCompare.filter(el => el.reimbursementFuneralBenefit?.toString() === 'true').length > 1;
    if (moreThanOneRDF) {

      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningMoreThanOneRDF",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]).subscribe(res => {
        this.item.reimbursementFuneralBenefit = false;
      });
      return;
    }

    //ID do beneficiario
    this.beneficiaryIDsService.itemVerifyHasId(this.item, this.itemList, true);

    //Campo Tipo de documento de identificação está vazio caso seja escolhida a opção "Tem nacionalidade portuguesa=Não"
    if (this.item.hasNacPT?.toString() == 'false') {
      this.item.identificationDocumentType = 'P';
    } else {
      if (this.item.hasNacPT?.toString() == 'true') {
        this.item.identificationDocumentType = "B";
      } 
    }


    super.markTouched();

    super.onEdit(isEdit);
  }

  onRemove(isEdit: boolean) {
    var listToAlter = [...this.itemList];

    //Ao eliminar o último representado da lista num pedido no estado Ativo|Devolvido ao Remetente deve aparecer um pop up impeditivo com mensagem
    if (this.stateCode == StateCode.Ativo && this.statePhase == StatePhase.DevolvidoAoRemetente) {
      const beneficiaryList = this.itemList;
      let showModal = false;
      if (this.isBeneficiary) {
        const copyList = [...beneficiaryList];
        const indexOf = copyList
          .findIndex(el => el.beneficiaryID == this.item.beneficiaryID);
        if (indexOf > -1) {
          copyList.splice(indexOf, 1);
        }
        // Testa se só resta o remetente (habilitanto com beneficiaryID igual a 1)
        if (copyList.length === 1 && copyList[0].beneficiaryID === 1) {
          showModal = true;
        } else {
          if (this.item.stateRL == LegalRepresentationState.RepresentaçaoAguardarDocumentos) {
            showModal = false;
          } else {
            showModal = true;
          }
        }
      } else {
        if (beneficiaryList?.length == 1 && beneficiaryList[0].beneficiaryID === this.item.beneficiaryID) {
          showModal = true;
        } else {
          if (this.item.stateRL == LegalRepresentationState.RepresentaçaoAguardarDocumentos) {
            showModal = false;
          } else {
            showModal = true;
          }
        }
      }
      if (showModal) {
        let modal = <models.BaseModalVM>{
          isError: false,
          message: "WorkflowCreatePM.PreStage.CardRepresentados.LastRepresentativeAlert",
          param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check"
          }
        };

        this.modalService.showModals([modal]).subscribe(result => {
          return;
        });
        return;
      }

    }



    if (isEdit) {
      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.ConfirmaRemover",
        param: {},
        //cancelButton: {
        //  hideButton: true,
        //  buttonText: "Ok",
        //  buttonClass: 'btn-primary',
        //  iconClass: "icon-check"
        //}
      };

      this.modalService.showModals([modal]).subscribe(result => {
        if (result) {
          const indexOf = listToAlter.indexOf(this.item);
          listToAlter.splice(indexOf);
          this.listChanged.emit(listToAlter);
        }
         
      });
    }
    
    else
      this.listChanged.emit(listToAlter);
  }

  public isFormValid(): boolean {
    let result = this.item.survivalPensionBenefit || this.item.funeralAllowanceBenefit || this.item.reimbursementFuneralBenefit;
    
    return result;
  }

  public hasPortugueseNationalityChange(hasNacPT: boolean) {
    if (hasNacPT.toString()=='true') {
      this.item.hasNIFPT = true;
    }
    else {
      this.item.hasNIFPT = null;
      this.item.NIF = null;
    }
  }

  public hasPortugueseNifChange(hasNIF: boolean) {
    if (!(hasNIF.toString() == 'true')) {
      this.item.NIF = null;
    }
    
  }

  public getStateText(state: string): string {
    return this.legalRepresentationState.getStateText(state?.toString());
  }

}
